export const HurricaneStatus = {
  DB: {
    label: "Disturbance",
    metric: 0,
    color: "gray.500",
    bg: "gray.50",
    weight: 1,
    rawColor: "#71717a",
    rawBg: "#fafafa",
  },
  TD: {
    label: "Tropical Depression",
    metric: 0,
    color: "blue.500",
    bg: "blue.50",
    weight: 8,
    rawColor: "#3b82f6",
    rawBg: "#eff6ff",
  },
  TS: {
    label: "Tropical Storm",
    metric: 0,
    color: "emerald.500",
    bg: "emerald.50",
    weight: 9,
    rawColor: "#10b981",
    rawBg: "#ecfdf5",
  },
  TY: {
    label: "Typhoon",
    metric: 0,
    color: "blue.700",
    bg: "blue.50",
    weight: 10,
    rawColor: "#1d4ed8",
    rawBg: "#eff6ff",
  },
  ST: {
    label: "Super Typhoon",
    metric: 0,
    color: "blue.800",
    bg: "blue.200",
    weight: 15,
    rawColor: "#1e40af",
    rawBg: "#bfdbfe",
  },
  SD: {
    label: "Subtropical Depression",
    metric: 0,
    color: "emerald.400",
    bg: "emerald.50",
    weight: 6,
    rawColor: "#34d399",
    rawBg: "#ecfdf5",
  },
  SS: {
    label: "Subtropical Storm",
    metric: 0,
    color: "emerald.300",
    bg: "white",
    weight: 5,
    rawColor: "#6ee7b7",
    rawBg: "#fff",
  },
  EX: {
    label: "Extratropical Systems",
    metric: 0,
    color: "fuchsia.500",
    bg: "fuchsia.50",
    size: "small",
    weight: 4,
    rawColor: "#d946ef",
    rawBg: "#fdf4ff",
  },
  PT: {
    label: "Post Tropical",
    metric: 0,
    color: "emerald.600",
    bg: "emerald.100",
    weight: 3,
    rawColor: "#059669",
    rawBg: "#d1fae5",
  },
  IN: {
    label: "Inland",
    metric: 0,
    color: "orange.600",
    bg: "orange.50",
    weight: 1,
    rawColor: "#ea580c",
    rawBg: "#fff7ed",
  },
  DS: {
    label: "Dissipating",
    metric: 0,
    color: "blue.500",
    bg: "blue.50",
    weight: 2,
    rawColor: "#3b82f6",
    rawBg: "#eff6ff",
  },
  LO: {
    label: "Low",
    metric: 0,
    color: "blue.500",
    bg: "blue.50",
    weight: 1,
    rawColor: "#3b82f6",
    rawBg: "#eff6ff",
  },
  WV: {
    label: "Tropical Wave",
    metric: 0,
    color: "lightBlue.700",
    bg: "lightBlue.200",
    weight: 2,
    rawColor: "#0369a1",
    rawBg: "#bae6fd",
  },
  ET: {
    label: "Extrapolated",
    metric: 0,
    color: "blue.700",
    bg: "blue.200",
    weight: 1,
    rawColor: "#1d4ed8",
    rawBg: "#bfdbfe",
  },
  MD: {
    label: "Monsoon Depression",
    metric: 0,
    color: "indigo.700",
    bg: "indigo.200",
    weight: 1,
    rawColor: "#4338ca",
    rawBg: "#c7d2fe",
  },
  XX: {
    label: "Unknown",
    metric: 0,
    color: "gray.700",
    bg: "gray.200",
    weight: 0,
    rawColor: "#3f3f46",
    rawBg: "#e4e4e7",
  },
  H1: {
    label: "Category 1",
    metric: 0,
    color: "green.700",
    bg: "green.200",
    weight: 10,
    rawColor: "#15803d",
    rawBg: "#bbf7d0",
  },
  H2: {
    label: "Category 2",
    metric: 0,
    color: "#B45D09",
    bg: "#FDE698",
    weight: 20,
    rawColor: "#B45D09",
    rawBg: "#FDE698",
  },
  H3: {
    label: "Category 3",
    metric: 0,
    color: "orange.700",
    bg: "orange.200",
    weight: 30,
    rawColor: "#c2410c",
    rawBg: "#fed7aa",
  },
  H4: {
    label: "Category 4",
    metric: 0,
    color: "red.700",
    bg: "red.200",
    weight: 40,
    rawColor: "#b91c1c",
    rawBg: "#fecaca",
  },
  H5: {
    label: "Category 5",
    metric: 0,
    color: "#660050",
    bg: "#F0DAEB",
    weight: 50,
    rawColor: "#660050",
    rawBg: "#F0DAEB",
  },
  NR: {
    label: "Not Reported",
    metric: 0,
    color: "gray.700",
    bg: "gray.200",
    weight: 0,
    rawColor: "#3f3f46",
    rawBg: "#e4e4e7",
  },
};

export const weighHurricaneLabels = (label: keyof typeof HurricaneStatus) => {
  return HurricaneStatus[label].weight;
};
